import React from "react";
import FclStandardReportPage from "@/components/reports/FclStandardReportPage";
import { FCL_REPORT_PAGE_CONFIG } from "@/pages/reports/shared/fclReportPageConfig";

export default function FclImportFileCancellationReportPage() {
    return <FclStandardReportPage config={FCL_REPORT_PAGE_CONFIG.importFileCancellationReport} />;
}
